var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeStat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5165 2.36667L3.02484 5.86667C2.27484 6.45 1.6665 7.69167 1.6665 8.63334V14.8083C1.6665 16.7417 3.2415 18.325 5.17484 18.325H14.8248C16.7582 18.325 18.3332 16.7417 18.3332 14.8167V8.75C18.3332 7.74167 17.6582 6.45 16.8332 5.875L11.6832 2.26667C10.5165 1.45 8.6415 1.49167 7.5165 2.36667Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 15H11.25C12.625 15 13.75 13.875 13.75 12.5V10C13.75 8.625 12.625 7.5 11.25 7.5H8.75C7.375 7.5 6.25 8.625 6.25 10V12.5C6.25 13.875 7.375 15 8.75 15Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5V15",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 11.25H13.75",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeStat);
export default __webpack_public_path__ + "static/media/home-stat.d8267a6d029f00351a28995f5c766c72.svg";
export { ForwardRef as ReactComponent };